import { UseToastOptions } from '@chakra-ui/react';

export const FILE_INPUT_ERROR_TOAST: UseToastOptions = {
  title: 'File import error',
  description:
    'We could not load any data from your file. Please ensure it is formatted correctly. If you have any questions, contact our support team.',
  status: 'error',
  isClosable: true,
};

export const EMPTY_SHEET_ERROR_TOAST: UseToastOptions = {
  title: 'Data set is missing',
  description: 'The file should have at least one column of data.',
  status: 'error',
  isClosable: true,
};

export const ROW_LIMIT_ERROR_TOAST: UseToastOptions = {
  title: 'Data set is too large',
  description: 'The maximum number of rows supported is 1,000',
  status: 'error',
  isClosable: true,
};

export const IMPORT_SUCCESS_TOAST: UseToastOptions = {
  title: 'File imported successfully',
  status: 'success',
  isClosable: true,
};

export const SUPPORTED_FILE_TYPES = ['.csv', '.xlsx'];
